<section class="mb-5 pb-0" *ngIf="tagCloudData.length > 0">
  <div class="d-flex justify-content-between align-items-end mb-4">
    <div>
      <h1 class="h1-main">Tag cloud</h1>
      <p class="p-main mb-0">Discover popular topics and trending keywords</p>
    </div>
    <button type="button" class="btn btn-walai px-4 py-2 rounded-pill shadow-sm" data-bs-toggle="modal"
      data-bs-target="#modalAllTagCloud">
      {{ "SeeAll" | translate }} <i class="bi bi-arrow-right ms-1"></i>
    </button>
  </div>

  <div class="tag-container">
    <a *ngFor="let item of tagCloudData | slice: 0:60; let i = index" target="_blank"
      [href]="'results?Ntk=TAGSFACET' + ntkLocation + '&Ntt=%22' + item.Value + '%22' + nttLocation" class="tag-badge">
      <span>#</span>{{ item.Value }}
    </a>
  </div>
</section>

<!-- Modal Tag Cloud -->
<div class="modal fade" id="modalAllTagCloud" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content shadow-2xl border-0">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold fs-3">All Tags</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="tag-container mt-3">
          <a *ngFor="let item of tagCloudData" target="_blank"
            [href]="'results?Ntk=TAGSFACET' + ntkLocation + '&Ntt=%22' + item.Value + '%22' + nttLocation"
            class="tag-badge" data-bs-dismiss="modal">
            <span>#</span>{{ item.Value }}
          </a>
        </div>
      </div>
      <div class="modal-footer border-0 pb-4 justify-content-center">
        <button type="button" class="btn btn-light px-5 py-2 rounded-pill" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>